
import TableList from "@components/templates/tablelist";
import { HttpProductList } from '@/service/inbound';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left"
            },
        };
    },
    methods: {
        ajaxRequest: HttpProductList,
    },
    computed: {
        SearchsData() {
            return [{
                label: "ERP SKU",
                tag: 'vInput',
                key: 'CN_sku',
                show: true,
            },
            {
                label: "名称",
                tag: 'vInput',
                key: 'EQ_name',
                show: true,
            }]
        },
        columns() {
            return [{
                title: "No.",
                type: 'index',
                width: 60,
            }, {
                title: "ERP SKU",
                key: 'sku'
            }, {
                title: "名称(中文)",
                key: 'name'
            }, {
                title: "名称(英文)",
                key: 'nameEn'
            },
            {
                title: "操作",
                width: 120,
                align: 'center',
                render: (h, { row }) => {
                    return h('vButton', {
                        props: {
                            theme: 'primary'
                        },
                        nativeOn: {
                            click: () => {
                                this.$emit('on-data', row)
                            }
                        }
                    }, "选择")
                }
            }]
        }
    }

};
